import Subject from "../cse4sub/Subject";
import React from 'react'
import csm from '../assets/CSEASH203mid21.pdf'
import cse from '../assets/CSEASH203end21.pdf'

export default function Pfps() {
  return (
    <div>
       <Subject title="Programming for problem Solving(ASH203)" mid="Q. Paper"
    book1="" book2="Let us C - Y.Kanetkar"
    book1Link="#"
    book2Link="https://www.pdfdrive.com/download.pdf?id=200713283&h=4cce05973e991044fbd9be81bf579318&u=cache&ext=pdf" 
    int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}